import { observer } from 'mobx-react-lite'
import { type BundleManagerViewModel } from '@/features/admin/bundle/BundleManagerViewModel'
import { BundleManagerCardContainer } from '@/features/admin/bundle/components/BundleManagerCard/BundleManagerCardContainer'

export interface BundleManagerContentContainerProps {
  vm: BundleManagerViewModel
}

export const BundleManagerContentContainer = observer(
  function BundleManagerContentContainer({
    vm,
  }: BundleManagerContentContainerProps) {
    return (
      <>
        {vm.workspaceVms.map((workspaceBundleVm) => (
          <BundleManagerCardContainer
            vm={workspaceBundleVm}
            workspace={workspaceBundleVm.workspace}
            key={workspaceBundleVm.id}
          />
        ))}
      </>
    )
  },
)
